import React, { useState } from 'react';
import {
  Row, Col, Form, Label, Input, Card, CardBody,
  Container, Button, FormFeedback
} from "reactstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const WasteTypeCreate = () => {
  const [name, setName] = useState('');
  const [nameAr, setNameAr] = useState('');
  const [isActive, setIsActive] = useState(true);
  const [image, setImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [validation, setValidation] = useState({
    name: null,
    image: null
  });
  const navigate = useNavigate();

  const validateFields = () => {
    let isValid = true;
    const newValidation = {
      name: name.trim() !== '',
      image: !!image
    };
    setValidation(newValidation);
    Object.values(newValidation).forEach(v => {
      if (!v) isValid = false;
    });
    return isValid;
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateFields()) return;
    setLoading(true);
  const formData = new FormData();
  formData.append("title", name);
  formData.append("title_ar", nameAr);
  formData.append("is_active", isActive ? 1 : 0);
  if (image) formData.append("icon", image);
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(`${process.env.REACT_APP_WEB_APP_URL}/api/web/waste-load-types/create`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
        body: formData,
      });
      const data = await response.json();
      if (response.status === 200) {
        toast.success('Waste type created successfully', { autoClose: 3000 });
        navigate(`/waste`);
      } else if (response.status === 422) {
        if (data?.errors) {
          Object.values(data.errors).forEach((errorArr) => {
            errorArr.forEach((errMsg) => toast.error(errMsg, { autoClose: 3000 }));
          });
        } else {
          toast.error(data?.message || 'Validation failed', { autoClose: 3000 });
        }
      } else {
        toast.error(data?.message || `Error: ${response.statusText}`, { autoClose: 3000 });
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to create waste type", { autoClose: 3000 });
    } finally {
      setLoading(false);
    }
  };

  document.title = "Add Waste Type | Moeen";

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Home" breadcrumbItem="Add Waste Type" />
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md="6">
                      <div className="mb-3">
                        <Label>Name</Label>
                        <Input
                          type="text"
                          placeholder="Enter waste type name"
                          value={name}
                          onChange={e => setName(e.target.value)}
                          valid={validation.name === true}
                          invalid={validation.name === false}
                        />
                        <FormFeedback tooltip>Name is required.</FormFeedback>
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="mb-3">
                        <Label>Name (Arabic)</Label>
                        <Input
                          type="text"
                          placeholder="Enter waste type name in Arabic"
                          value={nameAr}
                          onChange={e => setNameAr(e.target.value)}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <div className="mb-3">
                        <Label>Is Active</Label>
                        <div className="d-flex gap-3">
                          <Button color={isActive ? "success" : "secondary"} onClick={() => setIsActive(true)} active={isActive}>Active</Button>
                          <Button color={!isActive ? "danger" : "secondary"} onClick={() => setIsActive(false)} active={!isActive}>Inactive</Button>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <div className="mb-3">
                        <Label>Upload Image</Label>
                        <Input
                          type="file"
                          accept="image/*"
                          onChange={handleImageChange}
                        />
                        {previewUrl && (
                          <div className="mt-2">
                            <img
                              src={previewUrl}
                              alt="Preview"
                              style={{ width: "100px", height: "100px", objectFit: "cover" }}
                            />
                          </div>
                        )}
                        <FormFeedback tooltip>Image is required.</FormFeedback>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-4">
                    <Col className="text-end">
                      <Button type="submit" color="primary" disabled={loading}>
                        {loading ? (
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        ) : (
                          "Submit"
                        )}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default WasteTypeCreate;
